import { combineReducers } from '@reduxjs/toolkit';

import { activeHeaderBannersReducer } from '../app/store/header-banner-reducer';
import { articlesReducer } from '../app/store/articles-reducer';
import { categoriesReducer } from '../app/store/categories-reducer';
import { changePasswordReducer } from '../app/store/change-password-reducer';
import { configurationReducer } from '../app/store/configuration-reducer';
import { customerReducer } from '../app/store/customer-reducer';
import { feedbackReducer } from '../app/store/feedback-reducer';
import { newsReducer } from '../app/store/news-reducer';
import { searchHistoryReducer } from '../app/store/search-history-reducer';
import { shoppingCartReducer } from '../app/store/shopping-cart-reducer';
import { singleInquiryReducer } from '../app/store/single-inquiry-reducer';
import { snackbarReducer } from '../app/store/snackbar-reducers';
import { sponsorBannersReducer } from '../app/store/sponsor-banner-reducer';
import { supplierReducer } from '../app/store/supplier-reducer';
import { whishListReducer } from '../app/store/whish-list-reducer';

export const rootReducer = combineReducers({
    configuration: configurationReducer,
    supplier: supplierReducer,
    customer: customerReducer,
    articles: articlesReducer,
    snackbar: snackbarReducer,
    news: newsReducer,
    shoppingCart: shoppingCartReducer,
    whishList: whishListReducer,
    singleInquiry: singleInquiryReducer,
    changePassword: changePasswordReducer,
    headerBanners: activeHeaderBannersReducer,
    sponsorBanners: sponsorBannersReducer,
    feedback: feedbackReducer,
    categories: categoriesReducer,
    searchHistory: searchHistoryReducer,
});
